








































import "./review-card.less";
import Vue from "vue";
import { mapGetters } from "vuex";
import AddClassHover from "./../common/add-class-hover.js";

export default Vue.extend({
  name: "review-card",
  props: {
    id: String,
    review: Object,
    archivedOrDeleted: Boolean,
  },
  directives: { AddClassHover },
  computed: {
    ...mapGetters("review", ["canEdit"]),
    colorClass() {
      let trackingResult = (this as any).review.result;
      if (isNaN(trackingResult) || trackingResult === null) {
        return {
          "bio-card-default": true,
        };
      } else {
        return {};
      }
    },
    textColor() {
      let color = (this as any).color ? (this as any).color.toUpperCase() : (this as any).color;
      return !color || color === "#FFFFFF" || color === "#F5F2EE" ? "#515A6E" : "#FFFFFF";
    },
    color() {
      let context = this as any;

      //if (context.review.result === null || isNaN(context.review.result)) {
      //  return "#808080";
      //}

      let result = context.review.result;
      if (result === null || isNaN(result)) {
        result = 0;
      }

      if (context.review.archived === true) {
        return "#808080";
      }

      let grades = context.review && context.review.gradeModel ? JSON.parse(context.review.gradeModel) : [];
      grades = grades.sort(function (a, b) {
        return b.from - a.from;
      });

      grades = grades.filter((grade) => context.review.result * 100 >= grade.from);

      return grades.length > 0 ? grades[0].color : "#808080";
    },
    resultPercentage() {
      let context = this as any;
      if (context.review && context.review.result !== null && !isNaN(context.review.result)) {
        var percentage = Math.round(context.review.result * 100);
        return `${percentage}%`;
      } else {
        //return "NS";
        return "0%";
      }
    },
  },
  methods: {
    handleCardClick() {
      this.$router.push({ name: "review", params: { id: this.review.id } });
    },
    handleMenuItemClick(name) {
      this.$emit(name);
    },
  },
});
